import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useUsers } from 'hooks';
import jwt_decode from 'jwt-decode';
import PasswordResetErrorConditions from './PasswordResetErrorConditions';
import PasswordResetForm from './PasswordResetForm';
import PasswordResetSuccess from './PasswordResetSuccess';

const PasswordReset = () => {
  const location = useLocation();
  const parsed = queryString.parse(location.search);

  const { userResetPassword, getError } = useUsers();

  const [sentPassword, setSentPassword] = useState(false);

  var now = new Date();
  if (parsed?.ac === undefined) {
    return <PasswordResetErrorConditions error={{ statusCode: 401, message: 'Token is missing' }} />;
  }
  var decoded = jwt_decode(parsed.ac);
  var expiration = new Date(decoded.exp * 1000);

  const onSubmit = async (password) => {
    setSentPassword(true);
    userResetPassword({ password: password }, parsed);
  };

  if (getError !== undefined || now > expiration) {
    let error = getError;
    error = { ...error, expiration: expiration };
    if (sentPassword === true) {
      setSentPassword(false);
    }
    return <PasswordResetErrorConditions error={error} />;
  } else if (sentPassword) {
    return <PasswordResetSuccess />;
  } else {
    return <PasswordResetForm onSubmit={onSubmit} expiration={expiration.toString()} />;
  }
};

PasswordReset.propTypes = {
  authError: PropTypes.object,
};

PasswordReset.defaultProps = {
  authError: undefined,
};

export default PasswordReset;
